import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var AdvertisingUnitDtoAdTypeInline;
(function (AdvertisingUnitDtoAdTypeInline) {
    AdvertisingUnitDtoAdTypeInline["DIGITAL"] = "DIGITAL";
    AdvertisingUnitDtoAdTypeInline["MAILING"] = "MAILING";
    AdvertisingUnitDtoAdTypeInline["EMAIL"] = "EMAIL";
    AdvertisingUnitDtoAdTypeInline["ADDRESSED_MAILING"] = "ADDRESSED_MAILING";
    AdvertisingUnitDtoAdTypeInline["ONLINE"] = "ONLINE";
})(AdvertisingUnitDtoAdTypeInline || (AdvertisingUnitDtoAdTypeInline = {}));
export var AdvertisingUnitDtoGradationInline;
(function (AdvertisingUnitDtoGradationInline) {
    AdvertisingUnitDtoGradationInline["HIGH"] = "HIGH";
    AdvertisingUnitDtoGradationInline["MEDIUM"] = "MEDIUM";
    AdvertisingUnitDtoGradationInline["LOW"] = "LOW";
    AdvertisingUnitDtoGradationInline["NOT_AVAILABLE"] = "NOT_AVAILABLE";
})(AdvertisingUnitDtoGradationInline || (AdvertisingUnitDtoGradationInline = {}));
export var PdfRowConfigPlaceholders;
(function (PdfRowConfigPlaceholders) {
    PdfRowConfigPlaceholders["PAYMENT_PERIOD"] = "PAYMENT_PERIOD";
    PdfRowConfigPlaceholders["PAYMENT_DATE"] = "PAYMENT_DATE";
    PdfRowConfigPlaceholders["EARLY_PAYMENT_PERIOD"] = "EARLY_PAYMENT_PERIOD";
    PdfRowConfigPlaceholders["EARLY_PAYMENT_DATE"] = "EARLY_PAYMENT_DATE";
    PdfRowConfigPlaceholders["EARLY_PAYMENT_COMMISSION"] = "EARLY_PAYMENT_COMMISSION";
    PdfRowConfigPlaceholders["EARLY_PAYMENT_AMOUNT"] = "EARLY_PAYMENT_AMOUNT";
    PdfRowConfigPlaceholders["EARLY_PAYMENT_NET_TOTAL"] = "EARLY_PAYMENT_NET_TOTAL";
})(PdfRowConfigPlaceholders || (PdfRowConfigPlaceholders = {}));
export var ProductionDto;
(function (ProductionDto) {
    ProductionDto["IN_HOUSE"] = "IN_HOUSE";
    ProductionDto["IN_HOUSE_AND_ADVERTISER_LAYOUT"] = "IN_HOUSE_AND_ADVERTISER_LAYOUT";
    ProductionDto["THIRD_PARTY"] = "THIRD_PARTY";
})(ProductionDto || (ProductionDto = {}));
export var VisibilityMode;
(function (VisibilityMode) {
    VisibilityMode["VISIBLE"] = "VISIBLE";
    VisibilityMode["HIDDEN"] = "HIDDEN";
    VisibilityMode["TRANSPARENT"] = "TRANSPARENT";
})(VisibilityMode || (VisibilityMode = {}));
export var AdTypeDto;
(function (AdTypeDto) {
    AdTypeDto["DIGITAL"] = "DIGITAL";
    AdTypeDto["MAILING"] = "MAILING";
    AdTypeDto["ONLINE"] = "ONLINE";
    AdTypeDto["EMAIL"] = "EMAIL";
    AdTypeDto["ADDRESSED_MAILING"] = "ADDRESSED_MAILING";
})(AdTypeDto || (AdTypeDto = {}));
export var Language;
(function (Language) {
    Language["GERMAN"] = "GERMAN";
    Language["FRENCH"] = "FRENCH";
    Language["ITALIAN"] = "ITALIAN";
})(Language || (Language = {}));
export var DocumentType;
(function (DocumentType) {
    DocumentType["ORDER"] = "ORDER";
    DocumentType["ORDER_PORTRAIT"] = "ORDER_PORTRAIT";
    DocumentType["OFFER"] = "OFFER";
    DocumentType["OFFER_PORTRAIT"] = "OFFER_PORTRAIT";
    DocumentType["REPORT"] = "REPORT";
    DocumentType["INVOICE"] = "INVOICE";
    DocumentType["CREDIT"] = "CREDIT";
    DocumentType["PAYOUT_REPORT"] = "PAYOUT_REPORT";
    DocumentType["PAYOUT_SUMMARY_REPORT"] = "PAYOUT_SUMMARY_REPORT";
    DocumentType["CREDIT_CARD_RECEIPT"] = "CREDIT_CARD_RECEIPT";
    DocumentType["POST_ADDRESS"] = "POST_ADDRESS";
    DocumentType["POST_LABELS"] = "POST_LABELS";
    DocumentType["POST_REMINDER"] = "POST_REMINDER";
    DocumentType["POSTADMANAGER_SOLUTION_OFFER"] = "POSTADMANAGER_SOLUTION_OFFER";
    DocumentType["POSTADMANAGER_DETAIL_OFFER"] = "POSTADMANAGER_DETAIL_OFFER";
    DocumentType["POSTADMANAGER_TASKS_TIMETABLE"] = "POSTADMANAGER_TASKS_TIMETABLE";
    DocumentType["POSTADMANAGER_INVOICE"] = "POSTADMANAGER_INVOICE";
    DocumentType["POSTADMANAGER_INVOICE_ACCOUNTING_LIST"] = "POSTADMANAGER_INVOICE_ACCOUNTING_LIST";
    DocumentType["POSTADMANAGER_BRIEFING"] = "POSTADMANAGER_BRIEFING";
    DocumentType["SELFBOOKING_ORDER"] = "SELFBOOKING_ORDER";
    DocumentType["SELFBOOKING_INVOICE"] = "SELFBOOKING_INVOICE";
    DocumentType["SELFBOOKING_INVOICE_SUMMARY"] = "SELFBOOKING_INVOICE_SUMMARY";
    DocumentType["SELFBOOKING_RECEIPT_SUMMARY"] = "SELFBOOKING_RECEIPT_SUMMARY";
    DocumentType["SELFBOOKING_CAMPAIGN_RECEIPT"] = "SELFBOOKING_CAMPAIGN_RECEIPT";
    DocumentType["SELFBOOKING_BALANCE_RECEIPT"] = "SELFBOOKING_BALANCE_RECEIPT";
    DocumentType["CAMPAIGN_INSIGHTS"] = "CAMPAIGN_INSIGHTS";
})(DocumentType || (DocumentType = {}));
export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["DE"] = "DE";
    LanguageCode["EN"] = "EN";
    LanguageCode["FR"] = "FR";
    LanguageCode["IT"] = "IT";
})(LanguageCode || (LanguageCode = {}));
export var ServiceAdTypeEnum;
(function (ServiceAdTypeEnum) {
    ServiceAdTypeEnum["DIGITAL"] = "DIGITAL";
    ServiceAdTypeEnum["MAILING"] = "MAILING";
    ServiceAdTypeEnum["EMAIL"] = "EMAIL";
    ServiceAdTypeEnum["ADDRESSED_MAILING"] = "ADDRESSED_MAILING";
    ServiceAdTypeEnum["ONLINE"] = "ONLINE";
    ServiceAdTypeEnum["GENERAL"] = "GENERAL";
})(ServiceAdTypeEnum || (ServiceAdTypeEnum = {}));
export var TaskTypeEnum;
(function (TaskTypeEnum) {
    TaskTypeEnum["MILESTONE"] = "MILESTONE";
    TaskTypeEnum["ACTIVITY"] = "ACTIVITY";
    TaskTypeEnum["RELEASE"] = "RELEASE";
})(TaskTypeEnum || (TaskTypeEnum = {}));
export var TaskPhaseEnum;
(function (TaskPhaseEnum) {
    TaskPhaseEnum["PREPARATION"] = "PREPARATION";
    TaskPhaseEnum["PLAYOUT"] = "PLAYOUT";
    TaskPhaseEnum["POSTPROCESSING"] = "POSTPROCESSING";
})(TaskPhaseEnum || (TaskPhaseEnum = {}));
export var TaskChannelEnum;
(function (TaskChannelEnum) {
    TaskChannelEnum["UNADDRESSED"] = "UNADDRESSED";
    TaskChannelEnum["SERVICE"] = "SERVICE";
    TaskChannelEnum["ADDRESSED"] = "ADDRESSED";
    TaskChannelEnum["ONLINE"] = "ONLINE";
    TaskChannelEnum["DIGITAL"] = "DIGITAL";
    TaskChannelEnum["EMAIL"] = "EMAIL";
})(TaskChannelEnum || (TaskChannelEnum = {}));
export var PositionType;
(function (PositionType) {
    PositionType["DIGITAL"] = "DIGITAL";
    PositionType["UNADDRESSED"] = "UNADDRESSED";
    PositionType["ADDRESSED"] = "ADDRESSED";
    PositionType["EMAIL"] = "EMAIL";
    PositionType["ONLINE"] = "ONLINE";
    PositionType["SERVICE"] = "SERVICE";
    PositionType["DISCOUNT"] = "DISCOUNT";
})(PositionType || (PositionType = {}));
export var PresentationField;
(function (PresentationField) {
    PresentationField["REPORT_TITLE"] = "REPORT_TITLE";
    PresentationField["GENERATED_AT"] = "GENERATED_AT";
    PresentationField["POSITION_NAME"] = "POSITION_NAME";
    PresentationField["START_DATE"] = "START_DATE";
    PresentationField["END_DATE"] = "END_DATE";
    PresentationField["TYPE"] = "TYPE";
    PresentationField["AD_TYPE_SIZES"] = "AD_TYPE_SIZES";
    PresentationField["AMOUNT"] = "AMOUNT";
    PresentationField["IMPRESSIONS"] = "IMPRESSIONS";
    PresentationField["DELIVERY_DATE"] = "DELIVERY_DATE";
    PresentationField["CLICKS"] = "CLICKS";
    PresentationField["CTR"] = "CTR";
    PresentationField["FIXED_PRICE"] = "FIXED_PRICE";
    PresentationField["WEBSITE"] = "WEBSITE";
    PresentationField["PERIOD"] = "PERIOD";
    PresentationField["PLATFORMS"] = "PLATFORMS";
    PresentationField["FORMATS"] = "FORMATS";
    PresentationField["GUARANTEED_IMPRESSIONS"] = "GUARANTEED_IMPRESSIONS";
    PresentationField["DELIVERED_IMPRESSIONS"] = "DELIVERED_IMPRESSIONS";
    PresentationField["DELIVERED_RATE"] = "DELIVERED_RATE";
    PresentationField["CLIENT_CONTACT"] = "CLIENT_CONTACT";
    PresentationField["SALES_CONTACT"] = "SALES_CONTACT";
    PresentationField["DAILY_IMPRESSIONS_FROM_THE_CAMPAIGN"] = "DAILY_IMPRESSIONS_FROM_THE_CAMPAIGN";
    PresentationField["COMMENT"] = "COMMENT";
    PresentationField["CAMPAIGN_VISUALS"] = "CAMPAIGN_VISUALS";
    PresentationField["DISTRIBUTION"] = "DISTRIBUTION";
    PresentationField["DESKTOPS_AND_LAPTOPS"] = "DESKTOPS_AND_LAPTOPS";
    PresentationField["TABLETS"] = "TABLETS";
    PresentationField["MOBILE_PHONES"] = "MOBILE_PHONES";
    PresentationField["TELEVISION"] = "TELEVISION";
    PresentationField["GAME_CONSOLES"] = "GAME_CONSOLES";
    PresentationField["SET_TOP_BOX"] = "SET_TOP_BOX";
    PresentationField["MEDIA_PLAYERS"] = "MEDIA_PLAYERS";
    PresentationField["OTHER_DEVICES"] = "OTHER_DEVICES";
})(PresentationField || (PresentationField = {}));
export var PdfType;
(function (PdfType) {
    PdfType["ORDER"] = "ORDER";
    PdfType["OFFER"] = "OFFER";
    PdfType["REPORT"] = "REPORT";
    PdfType["PAYOUT_REPORT"] = "PAYOUT_REPORT";
    PdfType["PAYOUT_SUMMARY_REPORT"] = "PAYOUT_SUMMARY_REPORT";
    PdfType["INVOICE"] = "INVOICE";
    PdfType["CREDIT"] = "CREDIT";
    PdfType["CREDIT_CARD_RECEIPT"] = "CREDIT_CARD_RECEIPT";
    PdfType["POSTADMANAGER_SOLUTION_OFFER"] = "POSTADMANAGER_SOLUTION_OFFER";
    PdfType["POSTADMANAGER_DETAIL_OFFER"] = "POSTADMANAGER_DETAIL_OFFER";
    PdfType["POSTADMANAGER_TASKS_TIMETABLE"] = "POSTADMANAGER_TASKS_TIMETABLE";
    PdfType["POSTADMANAGER_INVOICE"] = "POSTADMANAGER_INVOICE";
    PdfType["POSTADMANAGER_INVOICE_ACCOUNTING_LIST"] = "POSTADMANAGER_INVOICE_ACCOUNTING_LIST";
    PdfType["POSTADMANAGER_BRIEFING"] = "POSTADMANAGER_BRIEFING";
    PdfType["SELFBOOKING_ORDER"] = "SELFBOOKING_ORDER";
    PdfType["SELFBOOKING_CAMPAIGN_RECEIPT"] = "SELFBOOKING_CAMPAIGN_RECEIPT";
    PdfType["SELFBOOKING_BALANCE_RECEIPT"] = "SELFBOOKING_BALANCE_RECEIPT";
    PdfType["SELFBOOKING_INVOICE"] = "SELFBOOKING_INVOICE";
    PdfType["SELFBOOKING_INVOICE_SUMMARY"] = "SELFBOOKING_INVOICE_SUMMARY";
    PdfType["SELFBOOKING_RECEIPT_SUMMARY"] = "SELFBOOKING_RECEIPT_SUMMARY";
    PdfType["CAMPAIGN_INSIGHTS"] = "CAMPAIGN_INSIGHTS";
})(PdfType || (PdfType = {}));
export var PdfRow;
(function (PdfRow) {
    PdfRow["ACCOUNT_DETAILS"] = "ACCOUNT_DETAILS";
    PdfRow["ACTOR"] = "ACTOR";
    PdfRow["ACTIVITY"] = "ACTIVITY";
    PdfRow["AD_TYPE_SIZES"] = "AD_TYPE_SIZES";
    PdfRow["ADVERTISER"] = "ADVERTISER";
    PdfRow["ADDRESSED_MAILINGS"] = "ADDRESSED_MAILINGS";
    PdfRow["AMOUNT_TOTAL"] = "AMOUNT_TOTAL";
    PdfRow["EXISTING_CUSTOMERS_EXCLUDED"] = "EXISTING_CUSTOMERS_EXCLUDED";
    PdfRow["AMOUNT_KUBA"] = "AMOUNT_KUBA";
    PdfRow["AMOUNT_AZ"] = "AMOUNT_AZ";
    PdfRow["AMOUNT_DE"] = "AMOUNT_DE";
    PdfRow["AMOUNT_FR"] = "AMOUNT_FR";
    PdfRow["AMOUNT_IT"] = "AMOUNT_IT";
    PdfRow["SHIPPING_DETAILS"] = "SHIPPING_DETAILS";
    PdfRow["NET_PRICE"] = "NET_PRICE";
    PdfRow["VAT_NUMBER"] = "VAT_NUMBER";
    PdfRow["AGENCY"] = "AGENCY";
    PdfRow["AGENCY_NET"] = "AGENCY_NET";
    PdfRow["AMOUNT"] = "AMOUNT";
    PdfRow["AMOUNT_OF_BROADCASTS"] = "AMOUNT_OF_BROADCASTS";
    PdfRow["BANK_ACCOUNT_NUMBER"] = "BANK_ACCOUNT_NUMBER";
    PdfRow["BIC_SWIFT"] = "BIC_SWIFT";
    PdfRow["BILLING_ADDRESS"] = "BILLING_ADDRESS";
    PdfRow["BILLING_PERIOD"] = "BILLING_PERIOD";
    PdfRow["ISSUER_ADDRESS"] = "ISSUER_ADDRESS";
    PdfRow["BK_AMOUNT"] = "BK_AMOUNT";
    PdfRow["BK_PERCENTAGE"] = "BK_PERCENTAGE";
    PdfRow["BK_TOTAL"] = "BK_TOTAL";
    PdfRow["BLACK_AND_WHITE"] = "BLACK_AND_WHITE";
    PdfRow["BROKER"] = "BROKER";
    PdfRow["CAMPAIGN_DURATION"] = "CAMPAIGN_DURATION";
    PdfRow["CAMPAIGN_PLANING"] = "CAMPAIGN_PLANING";
    PdfRow["CANCELLATION"] = "CANCELLATION";
    PdfRow["CHANNEL"] = "CHANNEL";
    PdfRow["CLICKS"] = "CLICKS";
    PdfRow["COLOR"] = "COLOR";
    PdfRow["COMMENT"] = "COMMENT";
    PdfRow["CONSULTANT"] = "CONSULTANT";
    PdfRow["CONTACT"] = "CONTACT";
    PdfRow["COST_CARRIER"] = "COST_CARRIER";
    PdfRow["CPM"] = "CPM";
    PdfRow["CREDIT"] = "CREDIT";
    PdfRow["CTR"] = "CTR";
    PdfRow["CUSTOMER_CONTACT"] = "CUSTOMER_CONTACT";
    PdfRow["CUSTOMER_NET"] = "CUSTOMER_NET";
    PdfRow["CUSTOMER_NUMBER"] = "CUSTOMER_NUMBER";
    PdfRow["DATE"] = "DATE";
    PdfRow["DAY"] = "DAY";
    PdfRow["DELIVERY_RATE"] = "DELIVERY_RATE";
    PdfRow["DEPOSIT_FOR"] = "DEPOSIT_FOR";
    PdfRow["DIGITAL"] = "DIGITAL";
    PdfRow["DIGITAL_TOTAL"] = "DIGITAL_TOTAL";
    PdfRow["DIGITAL_TOTAL_NET"] = "DIGITAL_TOTAL_NET";
    PdfRow["DISCOUNT_AMOUNT"] = "DISCOUNT_AMOUNT";
    PdfRow["DISCOUNT_PERCENTAGE"] = "DISCOUNT_PERCENTAGE";
    PdfRow["DISCOUNT_TOTAL"] = "DISCOUNT_TOTAL";
    PdfRow["DISCOUNT_POSITIONS"] = "DISCOUNT_POSITIONS";
    PdfRow["EARLY_PAYMENT_TERMS"] = "EARLY_PAYMENT_TERMS";
    PdfRow["ADDITIONAL_TAX"] = "ADDITIONAL_TAX";
    PdfRow["ECPM_NET3"] = "ECPM_NET3";
    PdfRow["ELECTRONIC_BILL_IN"] = "ELECTRONIC_BILL_IN";
    PdfRow["EMAIL"] = "EMAIL";
    PdfRow["APPROVED_BY_USER_EMAIL"] = "APPROVED_BY_USER_EMAIL";
    PdfRow["END_DATE"] = "END_DATE";
    PdfRow["ENTER_INVOICE_NUMBER"] = "ENTER_INVOICE_NUMBER";
    PdfRow["EXPECTED_CREATIVES"] = "EXPECTED_CREATIVES";
    PdfRow["FIXED_PRICE"] = "FIXED_PRICE";
    PdfRow["FORMAT_SIZE"] = "FORMAT_SIZE";
    PdfRow["DOCUMENT_DATE"] = "DOCUMENT_DATE";
    PdfRow["GROSS"] = "GROSS";
    PdfRow["GROSS2"] = "GROSS2";
    PdfRow["GROSS3"] = "GROSS3";
    PdfRow["HOUR"] = "HOUR";
    PdfRow["IBAN"] = "IBAN";
    PdfRow["IMPRESSIONS"] = "IMPRESSIONS";
    PdfRow["INFORMATION"] = "INFORMATION";
    PdfRow["INTERACTIONS"] = "INTERACTIONS";
    PdfRow["INTERACTION_RATE"] = "INTERACTION_RATE";
    PdfRow["INTERNAL_NUMBER"] = "INTERNAL_NUMBER";
    PdfRow["INVOICE"] = "INVOICE";
    PdfRow["INVOICE_AMOUNT"] = "INVOICE_AMOUNT";
    PdfRow["INVOICE_DATE"] = "INVOICE_DATE";
    PdfRow["INVOICE_NUMBER"] = "INVOICE_NUMBER";
    PdfRow["PAYMENT_TERMS"] = "PAYMENT_TERMS";
    PdfRow["PREVIOUS_INVOICE_ID"] = "PREVIOUS_INVOICE_ID";
    PdfRow["INVOICE_DISCOUNT"] = "INVOICE_DISCOUNT";
    PdfRow["INVOICE_GROSS"] = "INVOICE_GROSS";
    PdfRow["INVOICE_NET"] = "INVOICE_NET";
    PdfRow["INVOICE_SUMMARY"] = "INVOICE_SUMMARY";
    PdfRow["RECEIPT_SUMMARY"] = "RECEIPT_SUMMARY";
    PdfRow["UNADDRESSED_POSITIONS"] = "UNADDRESSED_POSITIONS";
    PdfRow["IN_FAVOR_OF"] = "IN_FAVOR_OF";
    PdfRow["LIFE_TIME"] = "LIFE_TIME";
    PdfRow["LIST_PRICE"] = "LIST_PRICE";
    PdfRow["MARKETER"] = "MARKETER";
    PdfRow["MILESTONE"] = "MILESTONE";
    PdfRow["MAX_CPM"] = "MAX_CPM";
    PdfRow["MEDIA"] = "MEDIA";
    PdfRow["MONTH"] = "MONTH";
    PdfRow["NET"] = "NET";
    PdfRow["NONE"] = "NONE";
    PdfRow["NUMBER"] = "NUMBER";
    PdfRow["OFFER"] = "OFFER";
    PdfRow["ORDER"] = "ORDER";
    PdfRow["ONLINE"] = "ONLINE";
    PdfRow["ONLINE_TOTAL"] = "ONLINE_TOTAL";
    PdfRow["ONLINE_POSITIONS"] = "ONLINE_POSITIONS";
    PdfRow["PAYMENT_BY_CARD"] = "PAYMENT_BY_CARD";
    PdfRow["PAYOUT_CANCELLATION"] = "PAYOUT_CANCELLATION";
    PdfRow["PAYOUT_COMMENT"] = "PAYOUT_COMMENT";
    PdfRow["PAYOUT_NUMBER"] = "PAYOUT_NUMBER";
    PdfRow["PLAYOUT"] = "PLAYOUT";
    PdfRow["PHASE"] = "PHASE";
    PdfRow["PHONE"] = "PHONE";
    PdfRow["POSITION"] = "POSITION";
    PdfRow["POSITION_COMMENT"] = "POSITION_COMMENT";
    PdfRow["POSITION_NAME"] = "POSITION_NAME";
    PdfRow["POSITION_DATE"] = "POSITION_DATE";
    PdfRow["POSTPROCESSING"] = "POSTPROCESSING";
    PdfRow["PREPARATION"] = "PREPARATION";
    PdfRow["PRINT"] = "PRINT";
    PdfRow["PRINT_MATERIAL_DEADLINE"] = "PRINT_MATERIAL_DEADLINE";
    PdfRow["PRINT_TOTAL"] = "PRINT_TOTAL";
    PdfRow["PRINT_TOTAL_NET"] = "PRINT_TOTAL_NET";
    PdfRow["PRODUCTION_SIZE"] = "PRODUCTION_SIZE";
    PdfRow["PUBLICATION_DATE"] = "PUBLICATION_DATE";
    PdfRow["PUBLISHER_PAYOUT"] = "PUBLISHER_PAYOUT";
    PdfRow["QR_IBAN"] = "QR_IBAN";
    PdfRow["QR_REFERENCE"] = "QR_REFERENCE";
    PdfRow["RADIO"] = "RADIO";
    PdfRow["RADIO_TOTAL"] = "RADIO_TOTAL";
    PdfRow["RADIO_TOTAL_NET"] = "RADIO_TOTAL_NET";
    PdfRow["RECEIPT"] = "RECEIPT";
    PdfRow["REFERENCE_NUMBER"] = "REFERENCE_NUMBER";
    PdfRow["RELEASE"] = "RELEASE";
    PdfRow["REPORT"] = "REPORT";
    PdfRow["REVENUE"] = "REVENUE";
    PdfRow["RUNTIME"] = "RUNTIME";
    PdfRow["SALES_CONTACT"] = "SALES_CONTACT";
    PdfRow["SPOT_LENGTH"] = "SPOT_LENGTH";
    PdfRow["START_DATE"] = "START_DATE";
    PdfRow["SUBCONTRACTOR"] = "SUBCONTRACTOR";
    PdfRow["TOTAL"] = "TOTAL";
    PdfRow["MAILING_TOTAL"] = "MAILING_TOTAL";
    PdfRow["ADDRESSED"] = "ADDRESSED";
    PdfRow["ADDRESSED_MAILING_TOTAL"] = "ADDRESSED_MAILING_TOTAL";
    PdfRow["EMAIL_TOTAL"] = "EMAIL_TOTAL";
    PdfRow["SERVICE"] = "SERVICE";
    PdfRow["SERVICE_TOTAL"] = "SERVICE_TOTAL";
    PdfRow["REACH"] = "REACH";
    PdfRow["TOTAL_TABLE"] = "TOTAL_TABLE";
    PdfRow["TOTAL_REACH"] = "TOTAL_REACH";
    PdfRow["TOTAL_NETTO"] = "TOTAL_NETTO";
    PdfRow["TOTAL_GROSS"] = "TOTAL_GROSS";
    PdfRow["UNADDRESSED"] = "UNADDRESSED";
    PdfRow["UNADDRESSED_MAILINGS"] = "UNADDRESSED_MAILINGS";
    PdfRow["DIGITAL_POSITIONS"] = "DIGITAL_POSITIONS";
    PdfRow["SERVICE_POSITIONS"] = "SERVICE_POSITIONS";
    PdfRow["KUREPO"] = "KUREPO";
    PdfRow["FRANKIERLIZENZ"] = "FRANKIERLIZENZ";
    PdfRow["BSI"] = "BSI";
    PdfRow["TOP_UP_RECEIPT"] = "TOP_UP_RECEIPT";
    PdfRow["TOTAL_GROSS_VAT"] = "TOTAL_GROSS_VAT";
    PdfRow["TOTAL_INCL_VAT"] = "TOTAL_INCL_VAT";
    PdfRow["TOTAL_EXCL_VAT"] = "TOTAL_EXCL_VAT";
    PdfRow["TOTAL_NET"] = "TOTAL_NET";
    PdfRow["TOTAL_VAT"] = "TOTAL_VAT";
    PdfRow["TOTAL_NO_VAT"] = "TOTAL_NO_VAT";
    PdfRow["DOMESTIC_COUNTRY_ADDITIONAL_INFO"] = "DOMESTIC_COUNTRY_ADDITIONAL_INFO";
    PdfRow["FOREIGN_COUNTRY_ADDITIONAL_INFO"] = "FOREIGN_COUNTRY_ADDITIONAL_INFO";
    PdfRow["TV"] = "TV";
    PdfRow["TV_TOTAL"] = "TV_TOTAL";
    PdfRow["TV_TOTAL_NET"] = "TV_TOTAL_NET";
    PdfRow["TYPE"] = "TYPE";
    PdfRow["UNIQUE_IDENTIFIER"] = "UNIQUE_IDENTIFIER";
    PdfRow["USE_INVOICE_DETAILS"] = "USE_INVOICE_DETAILS";
    PdfRow["VAT"] = "VAT";
    PdfRow["VMK_AMOUNT"] = "VMK_AMOUNT";
    PdfRow["VMK_PERCENTAGE"] = "VMK_PERCENTAGE";
    PdfRow["VMK_TOTAL"] = "VMK_TOTAL";
    PdfRow["WEEK"] = "WEEK";
    PdfRow["ZERO_VAT_DOMESTIC"] = "ZERO_VAT_DOMESTIC";
    PdfRow["ZERO_VAT_FOREIGN"] = "ZERO_VAT_FOREIGN";
    PdfRow["YOUR_VAT"] = "YOUR_VAT";
    PdfRow["DISTRIBUTION_DATE"] = "DISTRIBUTION_DATE";
    PdfRow["DELIVERY_DATE"] = "DELIVERY_DATE";
    PdfRow["NUMBER_OF_SHIPMENTS_DE"] = "NUMBER_OF_SHIPMENTS_DE";
    PdfRow["NUMBER_OF_SHIPMENTS_FR"] = "NUMBER_OF_SHIPMENTS_FR";
    PdfRow["NUMBER_OF_SHIPMENTS_IT"] = "NUMBER_OF_SHIPMENTS_IT";
    PdfRow["NUMBER_OF_SHIPMENTS"] = "NUMBER_OF_SHIPMENTS";
    PdfRow["RANGE"] = "RANGE";
    PdfRow["PRICE"] = "PRICE";
    PdfRow["LIFETIME"] = "LIFETIME";
    PdfRow["QUANTITY"] = "QUANTITY";
    PdfRow["TARGETING_BOTTOM_INFO"] = "TARGETING_BOTTOM_INFO";
    PdfRow["AFFINITIES"] = "AFFINITIES";
    PdfRow["LANGUAGES"] = "LANGUAGES";
    PdfRow["TARGET_GROUP"] = "TARGET_GROUP";
    PdfRow["TARGETING_PAGE"] = "TARGETING_PAGE";
    PdfRow["INCOMES"] = "INCOMES";
    PdfRow["GENDERS"] = "GENDERS";
    PdfRow["HOUSEHOLD_SIZES"] = "HOUSEHOLD_SIZES";
    PdfRow["AGES"] = "AGES";
    PdfRow["ANALOG"] = "ANALOG";
    PdfRow["ANALOG_TOTAL"] = "ANALOG_TOTAL";
    PdfRow["NUMBER_OF_SELECTED_BRANCHES"] = "NUMBER_OF_SELECTED_BRANCHES";
    PdfRow["SURCHARGE_AMOUNT"] = "SURCHARGE_AMOUNT";
    PdfRow["PRODUCTION"] = "PRODUCTION";
    PdfRow["FORMAT"] = "FORMAT";
    PdfRow["CATEGORY_MANAGER_DEADLINE"] = "CATEGORY_MANAGER_DEADLINE";
    PdfRow["LAYOUT_DELIVERY_DEADLINE"] = "LAYOUT_DELIVERY_DEADLINE";
    PdfRow["ADVERTISEMENTS"] = "ADVERTISEMENTS";
    PdfRow["CONTACT_EMAIL"] = "CONTACT_EMAIL";
    PdfRow["CONTACT_PHONE"] = "CONTACT_PHONE";
    PdfRow["CALENDAR_WEEK"] = "CALENDAR_WEEK";
    PdfRow["SHARE_OF_VOICE"] = "SHARE_OF_VOICE";
    PdfRow["CREATIVE_DELIVERY_DEADLINE"] = "CREATIVE_DELIVERY_DEADLINE";
    PdfRow["POINT_OF_SALE"] = "POINT_OF_SALE";
    PdfRow["POINT_OF_SALE_TOTAL"] = "POINT_OF_SALE_TOTAL";
    PdfRow["POINT_OF_SALE_TOTAL_NET"] = "POINT_OF_SALE_TOTAL_NET";
    PdfRow["CREATION_DEADLINE"] = "CREATION_DEADLINE";
    PdfRow["EXTERNAL_REFERENCE"] = "EXTERNAL_REFERENCE";
    PdfRow["RAW_MATERIAL_DEADLINE"] = "RAW_MATERIAL_DEADLINE";
    PdfRow["POS_PRINT_MATERIAL_DEADLINE"] = "POS_PRINT_MATERIAL_DEADLINE";
    PdfRow["CROSSMEDIA"] = "CROSSMEDIA";
    PdfRow["CROSSMEDIA_TOTAL"] = "CROSSMEDIA_TOTAL";
    PdfRow["CROSSMEDIA_TOTAL_NET"] = "CROSSMEDIA_TOTAL_NET";
    PdfRow["CONSULTING"] = "CONSULTING";
    PdfRow["CONSULTING_TOTAL"] = "CONSULTING_TOTAL";
    PdfRow["CONSULTING_TOTAL_NET"] = "CONSULTING_TOTAL_NET";
    PdfRow["ACCOUNT_EXTERNAL_REFERENCE"] = "ACCOUNT_EXTERNAL_REFERENCE";
    PdfRow["COWO_WEEK"] = "COWO_WEEK";
    PdfRow["TARGETING_INVENTORY_FINDER_LINK"] = "TARGETING_INVENTORY_FINDER_LINK";
    PdfRow["INVOICE_CONTACT_NAME"] = "INVOICE_CONTACT_NAME";
    PdfRow["INVOICE_CONTACT_EMAIL"] = "INVOICE_CONTACT_EMAIL";
    PdfRow["DEADLINE_1"] = "DEADLINE_1";
    PdfRow["DEADLINE_2"] = "DEADLINE_2";
    PdfRow["DEADLINE_3"] = "DEADLINE_3";
    PdfRow["TOTAL_IMPRESSIONS"] = "TOTAL_IMPRESSIONS";
    PdfRow["TOTAL_CLICKS"] = "TOTAL_CLICKS";
    PdfRow["POST_BRIEFING_TITLE"] = "POST_BRIEFING_TITLE";
    PdfRow["PAM_NUMBER"] = "PAM_NUMBER";
    PdfRow["BSI_CRM_SHORT_NAME"] = "BSI_CRM_SHORT_NAME";
    PdfRow["LINK_TO_CAMPAIGN"] = "LINK_TO_CAMPAIGN";
    PdfRow["GOAL"] = "GOAL";
    PdfRow["CONTENT"] = "CONTENT";
    PdfRow["CONTENT_HINT"] = "CONTENT_HINT";
    PdfRow["TEXT_INPUT_PLACEHOLDER"] = "TEXT_INPUT_PLACEHOLDER";
    PdfRow["AREA"] = "AREA";
    PdfRow["TIMING"] = "TIMING";
    PdfRow["CHANNELS"] = "CHANNELS";
    PdfRow["ADDRESSED_CHANNELS"] = "ADDRESSED_CHANNELS";
    PdfRow["ONLINE_CHANNELS"] = "ONLINE_CHANNELS";
    PdfRow["DIGITAL_CHANNELS"] = "DIGITAL_CHANNELS";
    PdfRow["EMAIL_CHANNELS"] = "EMAIL_CHANNELS";
    PdfRow["OTHER_CHANNELS"] = "OTHER_CHANNELS";
    PdfRow["BUDGET"] = "BUDGET";
    PdfRow["DISCOUNTS"] = "DISCOUNTS";
    PdfRow["ADDRESSED_LETTERS_DISCOUNT"] = "ADDRESSED_LETTERS_DISCOUNT";
    PdfRow["DENY"] = "DENY";
    PdfRow["CONFIRM"] = "CONFIRM";
    PdfRow["TEXT_PERCENTAGE"] = "TEXT_PERCENTAGE";
    PdfRow["PROMOPOST_DISCOUNT"] = "PROMOPOST_DISCOUNT";
    PdfRow["SPECIAL_DISCOUNT"] = "SPECIAL_DISCOUNT";
    PdfRow["NOTES"] = "NOTES";
    PdfRow["OFFER_UNTIL"] = "OFFER_UNTIL";
    PdfRow["OFFER_UNTIL_COMMENT"] = "OFFER_UNTIL_COMMENT";
    PdfRow["NOTE_LEADTIME"] = "NOTE_LEADTIME";
    PdfRow["WEEK_NUMBER"] = "WEEK_NUMBER";
    PdfRow["NATIVE"] = "NATIVE";
    PdfRow["ADVISOR"] = "ADVISOR";
    PdfRow["ADDRESS"] = "ADDRESS";
    PdfRow["CREDIT_CARD_LAST_4"] = "CREDIT_CARD_LAST_4";
    PdfRow["PAYOUT_DATE_PREFIX"] = "PAYOUT_DATE_PREFIX";
    PdfRow["WEBSITE_NAME"] = "WEBSITE_NAME";
    PdfRow["COST_UNIT"] = "COST_UNIT";
    PdfRow["INCLUDING_TECH_FEE"] = "INCLUDING_TECH_FEE";
    PdfRow["SOCIODEMOGRAPHIC_TITLE"] = "SOCIODEMOGRAPHIC_TITLE";
    PdfRow["AFFINITIES_TITLE"] = "AFFINITIES_TITLE";
    PdfRow["LIFE_PHASES_TITLE"] = "LIFE_PHASES_TITLE";
    PdfRow["LIFE_EVENTS_TITLE"] = "LIFE_EVENTS_TITLE";
    PdfRow["CUSTOMER_FACTS_TITLE"] = "CUSTOMER_FACTS_TITLE";
    PdfRow["GEOGRAPHIC_TITLE"] = "GEOGRAPHIC_TITLE";
    PdfRow["LIFE_PHASES"] = "LIFE_PHASES";
    PdfRow["LIFE_EVENT"] = "LIFE_EVENT";
    PdfRow["CAR_OWNERSHIP"] = "CAR_OWNERSHIP";
    PdfRow["CAR_OWNERSHIP_BRAND"] = "CAR_OWNERSHIP_BRAND";
    PdfRow["CAR_OWNERSHIP_POWERTRAIN"] = "CAR_OWNERSHIP_POWERTRAIN";
    PdfRow["CAR_OWNERSHIP_FINANCING"] = "CAR_OWNERSHIP_FINANCING";
    PdfRow["PURCHASE_INTENT_TITLE"] = "PURCHASE_INTENT_TITLE";
    PdfRow["CAR_PURCHASE"] = "CAR_PURCHASE";
    PdfRow["CAR_PURCHASE_BRAND"] = "CAR_PURCHASE_BRAND";
    PdfRow["CAR_PURCHASE_POWERTRAIN"] = "CAR_PURCHASE_POWERTRAIN";
    PdfRow["CAR_PURCHASE_FINANCING"] = "CAR_PURCHASE_FINANCING";
    PdfRow["PROPERTY_ATTRIBUTES"] = "PROPERTY_ATTRIBUTES";
    PdfRow["STOP_STICKER"] = "STOP_STICKER";
    PdfRow["CHARGING_STATION"] = "CHARGING_STATION";
    PdfRow["OCCUPATION"] = "OCCUPATION";
    PdfRow["HOUSEHOLD_TYPE"] = "HOUSEHOLD_TYPE";
    PdfRow["VAT_EXEMPT"] = "VAT_EXEMPT";
    PdfRow["VAT_LIABLE"] = "VAT_LIABLE";
})(PdfRow || (PdfRow = {}));
export var PdfMediaType;
(function (PdfMediaType) {
    PdfMediaType["DIGITAL"] = "DIGITAL";
    PdfMediaType["PRINT"] = "PRINT";
    PdfMediaType["RADIO"] = "RADIO";
    PdfMediaType["TV"] = "TV";
    PdfMediaType["POS"] = "POS";
    PdfMediaType["ANALOG"] = "ANALOG";
    PdfMediaType["CONSULTING"] = "CONSULTING";
    PdfMediaType["CROSSMEDIA"] = "CROSSMEDIA";
    PdfMediaType["UNADDRESSED_MAILINGS"] = "UNADDRESSED_MAILINGS";
    PdfMediaType["DIGITAL_POSITIONS"] = "DIGITAL_POSITIONS";
    PdfMediaType["ADDRESSED_MAILINGS"] = "ADDRESSED_MAILINGS";
    PdfMediaType["EMAILS"] = "EMAILS";
    PdfMediaType["ONLINE_POSITIONS"] = "ONLINE_POSITIONS";
    PdfMediaType["SERVICE_POSITIONS"] = "SERVICE_POSITIONS";
    PdfMediaType["DISCOUNT_POSITIONS"] = "DISCOUNT_POSITIONS";
})(PdfMediaType || (PdfMediaType = {}));
export var ExternalFileStatus;
(function (ExternalFileStatus) {
    ExternalFileStatus["UPLOADING"] = "UPLOADING";
    ExternalFileStatus["COMPLETED"] = "COMPLETED";
})(ExternalFileStatus || (ExternalFileStatus = {}));
export var PdfOrientationType;
(function (PdfOrientationType) {
    PdfOrientationType["LANDSCAPE"] = "LANDSCAPE";
    PdfOrientationType["PORTRAIT"] = "PORTRAIT";
})(PdfOrientationType || (PdfOrientationType = {}));
export var CompanyIdentifier;
(function (CompanyIdentifier) {
    CompanyIdentifier["ADNZ"] = "ADNZ";
    CompanyIdentifier["PUB"] = "PUB";
})(CompanyIdentifier || (CompanyIdentifier = {}));
